// Validation helpers for the community-report form. Pulled out of ReportDialog
// to keep the component focused on rendering and submission orchestration.

const URL_PATTERN = /(https?:\/\/|www\.|\.com|\.ca|\.org|\.net)/i;

export const NOTE_MAX_LENGTH = 200;

export const validateReport = ({ consent, note, captcha, captchaAnswer }) => {
  if (!consent) return "Please confirm the consent checkbox.";
  if (URL_PATTERN.test(note)) return "URLs are not allowed in notes.";
  if (note.length > NOTE_MAX_LENGTH) return `Note must be ${NOTE_MAX_LENGTH} characters or fewer.`;
  if (!captcha) return "CAPTCHA not loaded.";
  if (Number.isNaN(parseInt(captchaAnswer, 10))) return "Please answer the CAPTCHA.";
  return null;
};

export const isUrlInNote = (note) => URL_PATTERN.test(note);
